import styled, { css } from 'styled-components';
import { CROSS_SELL_VERTICAL_BREAKPOINT } from '../../../utils/cross-sell';

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.gray8};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const OrdersHeader = styled.header`
  display: flex;
  flex-direction: column;
  margin: 1rem auto;

  .hefesto-input-wrapper__label-wrapper__label::after {
    content: '*';
    color: ${({ theme }) => theme.colors.purple};
  }

  > div {
    width: 100%;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.tablet}) {
    margin: 1rem auto 1.5rem auto;
    padding: 0;
  }

  & h1 {
    font-weight: 600;
    margin-bottom: 1rem;
    color: ${({ theme }) => theme.colors.grayDark3};
  }

  & > .subtitle {
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.grayDark4};
    font-family: ${({ theme }) => theme.fonts.workSans};
  }
`;

export const MessageWithoutEmitter = styled.h4`
  color: #495961;
  font-size: 24px;
  line-height: 32px;
  font-family: 'Source Sans Pro';
  font-weight: 600;
  text-align: center;
  width: 31rem;
`;

interface PageWrapperProps {
  showVerticalCrossSell?: boolean;
}

const HEADER_HEIGHT = '8rem';

export const PageWrapper = styled.div<PageWrapperProps>`
  ${({ showVerticalCrossSell }) =>
    showVerticalCrossSell &&
    css`
      display: grid;
      grid-template-columns: 1fr 20rem;
      grid-template-rows: 1fr;
      height: calc(100vh - ${HEADER_HEIGHT});
    `}
`;

export const ContentArea = styled.div<{ scrollable?: boolean }>`
  ${({ scrollable }) =>
    scrollable &&
    css`
      overflow-y: auto;
      overflow-x: hidden;
      min-height: 0;
      min-width: 0;
    `}
`;

export const CrossSellSidebar = styled.aside`
  overflow-y: auto;
  min-height: 0;
  background: ${({ theme }) => theme.colors.white};
  min-width: 20rem;

  @media (max-width: ${CROSS_SELL_VERTICAL_BREAKPOINT - 1}px) {
    display: none;
  }
`;
